import { IGlobalState } from '../../states/GlobalState';
import { getSecondsPerBeat } from '../../states/utils';
import './index.scss';

const TimeIndicator = ({
  state,
  cellSize,
  isSmall = false
}: {
  state: IGlobalState
  cellSize: { width: number, height: number }
  isSmall?: boolean
}) => {
  return (
    <div
      className={`component--time-indicator ${isSmall ? 'component--time-indicator--small' : ''}`}
      style={{
        left: `${(state.control.playheadTime / getSecondsPerBeat(state.control.bpm, state.control.signature)) * cellSize.width}px`
      }}
      onClick={(event) => {
        event.preventDefault()
        event.stopPropagation()
      }}
    ></div>
  )
}

export default TimeIndicator;
